import { Skeleton, TableBody, TableCell, TableRow } from "@mui/material";
import { FC } from "react";
import { TableSkeletonProps } from "../../interfaceTypes";

export const CustomTasksSkeleton: FC<TableSkeletonProps> = ({ noOfRows }) => (
  <TableBody>
    {new Array(noOfRows).fill(0).map((_, index) => (
      <TableRow key={`${index}-skeleton`}>
        <TableCell>
          <Skeleton variant="text" width={190} height={36} />
        </TableCell>

        <TableCell>
          <Skeleton variant="text" width={90} height={36} />
        </TableCell>

        <TableCell>
          <Skeleton variant="text" width={50} height={36} sx={{ marginLeft: 'auto' }} />
        </TableCell>
      </TableRow>
    ))}
  </TableBody>
);